<div class="header">
  <div class="d-flex justify-content-end mr-5 h-100 align-items-center" *ngIf="userProfileEnable">
    <app-user-profile></app-user-profile>
  </div>
</div>

